import { vgrmApp } from "@/secured/clients/vgrm";

vgrmApp.createApp()